/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['entathakusa', 'ekuseni', 'emini', 'ntambama', 'ebusuku'],
    ,
  ],
  ,
  [
    ['00:00', '06:00'], ['06:00', '10:00'], ['10:00', '13:00'], ['13:00', '19:00'],
    ['19:00', '24:00']
  ]
];
